export default function PlayerGeneralComponent({ image, name, position }) {

  return (
    <div className={`playerGeneral playerGeneral-${position}`}>
      <img src={image} title={name} alt={name || 'Equipo'} loading="lazy" width={22} height={22}/>
      <span className="playerGeneral-name">{name}</span>
    </div>
  )
}